module.exports = __webpack_public_path__ + "static/media/exterior12.aa5b078b.webp";